/**
 * Violet Chiclets.
 */ var violet = [
    {
        stopColor: '#8895FF',
        offset: 0
    },
    {
        stopColor: '#EF8DF8',
        offset: 100
    }
];

export { violet as default };
//# sourceMappingURL=violet.es.js.map
